
export const PREMIUM_PATIENT = "request-premium";
export const LOAD_SLOT = "load-slot";
export const CREATE_SLOT = "create-slot";

export function requestPremium(payload)
{
    return {
        type: PREMIUM_PATIENT,
        data: payload
    };
}
export function loadedSlot(payload) {
    return {
        type: LOAD_SLOT,
        payload: payload
    };
}export function createSlot(payload) {
    return {
        type: CREATE_SLOT,
        payload: payload
    };
}


// WEBPACK FOOTER //
// ./src/actions/premium.action.js